jQuery(($) => {

    $(".a-hamburger").click(function () {
        const isActive = $(this).hasClass("a-hamburger--active");

        $(this).toggleClass("a-hamburger--active");
        $(this).attr("aria-expanded", isActive ? "false" : "true");
    });
});